import usePaginatedLogList, { withMasterReview } from "../../../hooks/usePaginatedLogList";
import LogListError from "../../../components/LogListError";
import React, { useEffect, useState } from "react";
import {
  Button,
  Checkbox,
  DatePicker,
  Popconfirm,
  Select,
  Table,
  Tooltip,
} from "antd";
import { useNavigate } from "react-router-dom";
import { DeleteOutlined, EditOutlined, EyeFilled } from "@ant-design/icons";
import "../../css/common.css";
import { post } from "../../../services/services";
import {
  ApiURL,
  garbagelogdownloadPdfUrl,
} from "../../../services/apiConstants";
import { ErrorToast, SuccessToast } from "../../../widgets/AppToast";
import VoyageDetails from "../../../components/VoyageDetails";
import { formatDate } from "../../../utils/dateFormatter";
import useVoyageList from "../../../hooks/useVoyageList";
import { DOWNLOADPDF } from "../../../utils/downloadPdf";
import dayjs from "dayjs";
import { dateRanges } from "../../../Data/data";
import useUserData from "../../../hooks/useUserData";
import RequestFormModal_garbadge_1 from "../../../components/RequestModel_garbadge_1";

const GarbageLogBookList = () => {
  const user = useUserData();
  const navigate = useNavigate();
  const { voyageList } = useVoyageList();
  const { data: filteredData, setData: setFilteredData, loading: page_loader, load: loadRecords, pagination, error, retry } =
    usePaginatedLogList(ApiURL.list_garbage_records, "records", withMasterReview);
  const [staff_dashboard, set_staff_dashboard] = useState([]);
  const [voyage_ids, set_voyage_id] = useState("");
  const [voyage_status, set_voyage_status] = useState(true);
  const { RangePicker } = DatePicker;
  const [selectedMasterRows, setSelectedMasterRows] = useState([]);
  const [isModalVisible, setModalVisible] = useState(false);
  const [record_id, set_record_id] = useState("");
  const [dates, setDates] = useState([dayjs().subtract(2, "day"), dayjs()]);
  const [startDate, endDate] = dates?.map((d) => d.format("YYYY-MM-DD")) || [];

  useEffect(() => {
    if (voyageList?.length > 0) {
      const runningVoyage = voyageList.find(
        (voyage) => voyage.voyage_status === true
      );
      set_voyage_status(runningVoyage?.voyage_status);
      if (runningVoyage) {
        set_voyage_id(runningVoyage.id);
        if (runningVoyage.id) LIST_GARBAGE_LOGBOOK_API(runningVoyage.id);
      }
    }
  }, [voyageList]);

  useEffect(() => {
    const staff_dashboards = localStorage.getItem("staff_dashboard");
    const parsedData = JSON.parse(staff_dashboards);
    set_staff_dashboard(parsedData);
  }, []);

  const lastDate = localStorage.getItem("last_logbook_entry_date");

  const LIST_GARBAGE_LOGBOOK_API = (voyage_id) => {
    if (!voyage_id) return;
    return loadRecords({ voyage_id, garbage_part: "1" });
  };

  const DELETE_GARBAGE_RECORD = (garbage_id) => {
    const FORM_DATA = new FormData();
    FORM_DATA.append("record_id", garbage_id);
    FORM_DATA.append("garbage_part", "1");
    post(ApiURL.delete_garbage_record_st, FORM_DATA).then((res) => {
      if (res?.status == true) {
        SuccessToast("Success!!", res?.message);
        LIST_GARBAGE_LOGBOOK_API(voyage_ids);
      } else {
        ErrorToast("Error", res?.message);
      }
    });
  };

  const handleSelectAllMaster = (e) => {
    if (user?.data?.designation !== "Captain") return;
    const checked = e.target.checked;
    const updatedData = filteredData.map((item) => ({
      ...item,
      masterReviewed: item.chiefReviewed && checked,
    }));
    setFilteredData(updatedData);
    setSelectedMasterRows(
      checked && filteredData.every((item) => item.chiefReviewed)
        ? filteredData.map((item) => item.key)
        : []
    );
    CHANGE_ALL_CHIEF_MASTER_REVIEW_CHECK_BOX(1);
  };

  const handleMasterCheckboxChange = (e, record, index) => {
    // Only allow Captain to modify this
    if (user?.data?.designation !== "Captain") return;
    const checked = e.target.checked;
    const updatedData = [...filteredData];
    updatedData[index].masterReviewed = checked;
    if (checked) {
      CHANGE_CHIEF_MASTER_REVIEW_CHECK_BOX(record?.garbage_record_id, 1);
      setSelectedMasterRows([...selectedMasterRows, record.key]);
    } else {
      CHANGE_CHIEF_MASTER_REVIEW_CHECK_BOX(record?.garbage_record_id, 1);
      setSelectedMasterRows(
        selectedMasterRows.filter((key) => key !== record.key)
      );
    }
    setFilteredData(updatedData);
  };

  const CHANGE_ALL_CHIEF_MASTER_REVIEW_CHECK_BOX = () => {
    const FORM_DATA = new FormData();
    FORM_DATA.append("garbage_part", "1");
    post(ApiURL.update_multiple_checkboxes_st_garbage, FORM_DATA).then(
      (res) => {
        if (res?.status == true) {
          SuccessToast("Success message !!", res?.message);
          LIST_GARBAGE_LOGBOOK_API(voyage_ids);
        } else {
          ErrorToast("Error message", res?.message);
        }
      }
    );
  };

  const CHANGE_CHIEF_MASTER_REVIEW_CHECK_BOX = (record_id) => {
    const FORM_DATA = new FormData();
    FORM_DATA.append("record_id", record_id);
    FORM_DATA.append("garbage_part", "1");
    post(ApiURL.update_single_checkbox_st_garbage, FORM_DATA).then((res) => {
      if (res?.status == true) {
        SuccessToast("Success message !!", res?.message);
        LIST_GARBAGE_LOGBOOK_API(voyage_ids);
      } else {
        ErrorToast("Error message", res?.message);
      }
    });
  };

  const columns = [
    {
      title: "Id",
      dataIndex: "garbage_record_id",
      align: "center",
      key: "garbage_record_id",
      sorter: (a, b) => a.garbage_record_id - b.garbage_record_id,
      render: (garbage_record_id, record) => (
        <span
          style={{
            textDecoration: record?.soft_delete ? "line-through" : "none",
          }}
        >
          {garbage_record_id}
        </span>
      ),
    },
    {
      title: "Role",
      dataIndex: "staff_role",
      align: "center",
      key: "staff_role",
      render: (staff_role, record) => (
        <span
          style={{
            textDecoration: record?.soft_delete ? "line-through" : "none",
          }}
        >
          {staff_role}
        </span>
      ),
    },
    {
      title: "Garbage Type",
      dataIndex: "garbage_type",
      align: "center",
      key: "garbage_type",
      render: (garbage_type, record) => (
        <span
          style={{
            textDecoration: record?.soft_delete ? "line-through" : "none",
          }}
        >
          {garbage_type}
        </span>
      ),
    },

    {
      title: "Qnty Disposed (m3)",
      dataIndex: "quantity_disposed",
      align: "center",
      key: "quantity_disposed",
      render: (quantity_disposed, record) => (
        <span
          style={{
            textDecoration: record?.soft_delete ? "line-through" : "none",
          }}
        >
          {quantity_disposed}
        </span>
      ),
    },
    {
      title: "Method of Disposal",
      dataIndex: "method_of_disposal",
      align: "center",
      key: "method_of_disposal",
      render: (method_of_disposal, record) => (
        <span
          style={{
            textDecoration: record?.soft_delete ? "line-through" : "none",
          }}
        >
          {method_of_disposal}
        </span>
      ),
    },
    {
      title: "Date",
      dataIndex: "log_date_time",
      align: "center",
      key: "log_date_time",

      render: (log_date_time, record) => (
        <span
          style={{
            textDecoration: record?.soft_delete ? "line-through" : "none",
          }}
        >
          {formatDate(log_date_time)}
        </span>
      ),
    },
    {
      title: (
        <Tooltip
          title={
            selectedMasterRows?.length > 0
              ? `Selected: ${selectedMasterRows.join(", ")}`
              : "No selections"
          }
        >
          <div style={{ textAlign: "center" }}>
            <span>Confirm By Master</span>
            <Checkbox
              style={{ marginLeft: 8 }}
              onChange={handleSelectAllMaster}
              checked={
                filteredData.length > 0 &&
                filteredData.every((item) => item.masterReviewed)
              }
              indeterminate={
                filteredData.some((item) => item.masterReviewed) &&
                !filteredData.every((item) => item.masterReviewed)
              }
              disabled
            />
          </div>
        </Tooltip>
      ),
      dataIndex: "master_review",
      align: "center",
      key: "master_review",
      render: (text, record, index) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Checkbox
            disabled
            checked={record?.masterReviewed}
            onChange={(e) => handleMasterCheckboxChange(e, record, index)}

            // disabled={record?.soft_delete || user?.data?.designation !== "Captain"}
          />
          <span
            style={{
              marginLeft: 8,
              textDecoration: record?.soft_delete ? "line-through" : "none",
            }}
          >
            Confirm By Master
          </span>
        </div>
      ),
    },
    {
      title: "Action Status",
      align: "center",
      key: "Action",
      render: (text, record) => {
        return (
          <>
            {(() => {
              const isCaptain = user?.data?.designation === "Captain";
              const isSoftDeleted = record?.soft_delete;
              const reviewed = record?.reviewed_by_master;
              const garbageIdEncoded = btoa(record?.garbage_record_id);

              const handleEdit = () => {
                if (reviewed && isCaptain) {
                  setModalVisible(!isModalVisible);
                  set_record_id(record?.garbage_record_id);
                } else {
                  navigate(`/edit-garbage-log/${garbageIdEncoded}`);
                }
              };

              const viewButton = (
                <Tooltip title="View">
                  <Button
                    type="primary"
                    size="small"
                    onClick={() =>
                      navigate(`/edit-garbage-log/${garbageIdEncoded}`)
                    }
                    style={{ marginRight: "5px" }}
                    icon={<EyeFilled />}
                  />
                </Tooltip>
              );

              if (!isSoftDeleted && (isCaptain || record?.can_edit === true)) {
                return (
                  <>
                    <Tooltip
                      title={
                        !voyage_status
                          ? "Editing is disabled when voyage status is inactive."
                          : "Edit"
                      }
                    >
                      <span>
                        <Button
                          disabled={!voyage_status}
                          type="primary"
                          size="small"
                          onClick={handleEdit}
                          style={{ marginRight: "10px", marginLeft: "10px" }}
                          icon={<EditOutlined />}
                        />
                      </span>
                    </Tooltip>

                    {isCaptain && <Popconfirm
                      title="Delete Garbage Log"
                      description="Are you sure you want to delete this Garbage Log? This action cannot be undone."
                      onConfirm={() =>
                        DELETE_GARBAGE_RECORD(record?.garbage_record_id)
                      }
                      okText="Yes"
                      cancelText="No"
                    >
                      <Tooltip title="Delete">
                        <Button
                          type="primary"
                          size="small"
                          icon={<DeleteOutlined />}
                        />
                      </Tooltip>
                    </Popconfirm>}
                  </>
                );
              }

              return viewButton;
            })()}
          </>
        );
      },
    },
  ];

  return (
    <>
      <VoyageDetails
        staff_dashboard={staff_dashboard?.voyage_details}
        buttonShow={true}
        disabled={!voyage_status}
        buttonProps={{
          text: "Add Logs",
          className: "save_btn",
          onClick: () => navigate("/add-garbage-log"),
          onPress: () => navigate("/audit-trail-garbage"),
        }}
      />
      <div className="row">
        <div
          className="col-3"
          style={{ marginBottom: "13px", marginLeft: "15px" }}
        >
          <label className="block-label">Select Voyage Id</label>
          <Select
            placeholder="---- Select Voyage Id ----"
            style={{ width: "100%" }}
            value={voyage_ids}
            onChange={(value) => {
              const selectedVoyage = voyageList.find(
                (voyage) => voyage.id === value
              );
              if (selectedVoyage) {
                set_voyage_status(selectedVoyage.voyage_status);
              }
              set_voyage_id(value);
              LIST_GARBAGE_LOGBOOK_API(value);
            }}
          >
            {voyageList?.map((voyage) => (
              <Select.Option key={voyage.id} value={voyage.id}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <span>{`Voyage Id: ${voyage.id}`}</span>
                  <span
                    style={{
                      color:
                        voyage.voyage_status === true ? "#FFA500" : "#008000",
                      fontWeight: "550",
                      marginRight: "15px",
                    }}
                  >
                    {voyage.voyage_status === true ? "Running" : "Complete"}
                  </span>
                </div>
              </Select.Option>
            ))}
          </Select>
        </div>

        <div className="col-3"></div>
        <div
          className="col-6"
          style={{ display: "flex", justifyContent: "flex-end" }}
        >
          <div style={{ marginRight: "15px" }}>
            <label className="block-label">Select Start Date & End Date</label>
            <RangePicker
              presets={dateRanges}
              value={dates}
              onChange={setDates}
              format="YYYY-MM-DD"
              style={{ width: 350 }}
              disabledDate={(current) =>
                current && current > dayjs().endOf("day")
              }
            />
          </div>
          <div style={{ alignSelf: "flex-end" }}>
            <Button
              type="primary"
              className="save_btn"
              style={{ color: "white", marginBottom: "13px" }}
              onClick={() =>
                DOWNLOADPDF(
                  garbagelogdownloadPdfUrl,
                  voyage_ids,
                  startDate,
                  endDate
                )
              }
            >
              Download Pdf
            </Button>
          </div>
        </div>
      </div>
      <LogListError error={error} retry={retry} />
      <Table
        bordered
        columns={columns}
        dataSource={filteredData}
        pagination={pagination}
        rowKey="garbage_record_id"
        loading={page_loader}
        className="custom-table"
      />
      <RequestFormModal_garbadge_1
        visible={isModalVisible}
        record_id={record_id}
        voyage_ids={voyage_ids}
        setModalVisible={setModalVisible}
        onCancel={() => {
          setModalVisible(!isModalVisible);
        }}
      />
    </>
  );
};

export default GarbageLogBookList;
